import { FileInfo } from "@/twapp/objects/FileInfo";
import { OwnerType } from "@/twapp/server/FileEndpoint";
import _ from "lodash";

export interface IEntry {
    type: "file" | "folder";
    id: string;
    name: string;
    source: FileInfo;
    fullPath: string;
}

export interface IFile extends IEntry {
    type: "file";
    showPolitiker: boolean;
    showPublik: boolean;
}

export interface IEntrySet {
    files: IFile[];
    folders: IFolder[];
}

export interface IContainer extends IEntrySet {
    totalFolderCount: number;
    totalFileCount: number;
    totalPolitikerCount: number;
    totalPublikCount: number;
}

export interface IFolder extends IContainer, IEntry {
    type: "folder";
}

export interface IFileRoot extends IContainer {
    ownerId: string;
    ownerType: OwnerType;
}

export interface IEntrySelection extends IEntrySet {
    container: IContainer;
}

export function isFile(entry: IEntry): entry is IFile {
    return entry.type === 'file';
}

export function isFolder(container: IContainer): container is IFolder {
    return !!((container as IFolder).id);
}

export function getAllFiles(entries: IEntrySet): IFile[] {
    return _.concat(entries.files, _.flatMap(entries.folders, getAllFiles));
}

export function getAllFolders(entries: IEntrySet): IFolder[] {
    return _.concat(entries.folders, _.flatMap(entries.folders, getAllFolders));
}

export function getAllEntries(entries: IEntrySet): IEntry[] {
    return _.concat<IEntry>(entries.folders, entries.files, _.flatMap(entries.folders, getAllEntries));
}
